import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-toastify";
import { useDeleteUserMutation, useUpdateUserMutation } from "../../service/features/api";
import DeleteConfirmModal from "../../Modals/DeleteConfirmModal";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
} from "@mui/material";
// import SwitchToggle from "../../components/SwitchToggle";
import Pagination from "../../components/Panigation";
import { GENDER } from "../../constants/enum";

interface UserListProps {
  users: any[];
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  paginator: any;
  isLoading: boolean;
}

const UserList = ({ users, page, setPage, paginator, isLoading }: UserListProps) => {
  const navigate = useNavigate();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedDeleteId] = useState<string | null>(null);
  const [deleteUser, { isLoading: isDeleting }] = useDeleteUserMutation();
  const [updateUser] = useUpdateUserMutation();

  const handleDelete = async () => {
    if (selectedDeleteId) {
      try {
        await deleteUser(selectedDeleteId).unwrap();
        toast.success("User deleted successfully");
        setDeleteModalOpen(false);
      } catch (error: any) {
        toast.error(error?.data?.message || "Failed to delete user");
      }
    }
  };

  const handleStatusChange = async (user: any) => {
    try {
      // Toggle logic: If currently blocked (isBlocked: true), we want to unblock (isBlocked: false)
      // If currently not blocked (isBlocked: false), we want to block (isBlocked: true)
      const newStatus = !user.isBlocked;
      await updateUser({ id: user._id, isBlocked: newStatus }).unwrap();
      toast.success(newStatus ? "User disabled successfully" : "User enabled successfully");
    } catch (error: any) {
      toast.error(error?.data?.message || "Failed to update user status");
    }
  };

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>تفاصيل المستخدم / User Detail</TableCell>
              <TableCell>الجنس / Gender</TableCell>
              <TableCell>اسم الباقة / Plan Name</TableCell>
              <TableCell>السيارات المنشورة / Posted Cars</TableCell>
              <TableCell>السيارات المحفوظة / Saved Cars</TableCell>
              {/* <TableCell>Disable/Enable</TableCell> */}
              <TableCell>إجراء / Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">Loading...</TableCell>
              </TableRow>
            ) : users.length > 0 ? (
              users.map((user) => (
                <TableRow hover key={user._id}>
                  {/* USER DETAIL */}
                  <TableCell className="click_action">
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/manage-users/detail/${user._id}`);
                      }}
                      className="user_block click_action"
                      style={{ cursor: "pointer" }}
                    >
                      <figure>
                        <img
                          src={user.image || "/static/images/user_placeholder.png"}
                          alt="User"
                        />
                      </figure>
                      <p>
                        <b>{user.fullName || "N/A"}</b>
                        <span>{user.countryCode} {user.phone}</span>
                        <span>{user.email}</span>
                      </p>
                    </div>
                  </TableCell>

                  {/* GENDER */}
                  <TableCell>
                    {user.gender
                      ? Object.keys(GENDER).find(
                        (key) => GENDER[key as keyof typeof GENDER] === user.gender
                      ) || "N/A"
                      : "N/A"}
                  </TableCell>

                  {/* PLAN NAME */}
                  <TableCell>
                    {user?.plan?.name || "N/A"}
                  </TableCell>

                  {/* POSTED CARS */}
                  <TableCell>{user.carCount || "0"}</TableCell>

                  {/* SAVED CARS */}
                  <TableCell>{user.savedCar || "0"}</TableCell>

                  {/* STATUS */}
                  {/* <TableCell>
                    <SwitchToggle
                      checked={!user.isBlocked}
                      onChange={() => handleStatusChange(user)}
                    />
                  </TableCell> */}

                  {/* ACTIONS */}
                  <TableCell>
                    <div className="table_actions v2">
                      <Tooltip title="View" arrow>
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-users/detail/${user._id}`)
                          }
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                      </Tooltip>

                      {/* <Tooltip title="Edit" arrow>
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-users/edit/${user._id}`)
                          }
                        >
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Delete" arrow>
                        <IconButton onClick={() => {
                          setSelectedDeleteId(user._id);
                          setDeleteModalOpen(true);
                        }}>
                          <img src="/static/images/trash2_icon.svg" alt="Delete" />
                        </IconButton>
                      </Tooltip> */}
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">No users found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer >

      <DeleteConfirmModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDelete}
        isLoading={isDeleting}
        message="Are you sure you want to delete this user?"
      />

      {paginator?.itemCount > 10 && (
        <Pagination
          module={users}
          page={page}
          setPage={setPage}
          onPageChange={(newP: number) => setPage(newP)}
          totalPages={paginator?.pageCount || 1}
          totalCount={paginator?.itemCount || 0}
        />
      )}
    </>
  );
};

export default UserList;
